import dayjs from 'dayjs'
import { getLineChatSummary, getLineChatDetail } from '/src/@api/dashboard'
import { generateMockData } from 'src/utils'
import { getUserAccountOrder } from 'src/@api/login'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'

const readDeviceSnapshot = () => ({
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}'),
  currentDevice: JSON.parse(localStorage.getItem('currentDevice') || '{}')
})

const loadSummary = async ({ page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const username = deviceUser?.username || ''
  const deviceUdid = currentDevice?.['Unique Identifier'] || ''
  const orders = await getUserAccountOrder({ page: 1, pageSize: 10 })
  const lastOrder = orders.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]
  const response = await getLineChatSummary({
    username,
    params: { category: 'LINE_CHAT_SUMMARY', offset: (page - 1) * 50, limit: 50, deviceUdid }
  })
  let data = response.data.contents?.map(item => ({
    ...item,
    time: dayjs(item.snippetTimestamp).format('YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  const advanced = username == null || !('advanced' in response) || [true, 'true'].includes(response?.advanced)
  if (!advanced) {
    data = generateMockData(data).map((item, index) => index === 0 ? item : { ...item, PK: `${index}spyx` })
  }

  let defaultSelectData = []
  if (page === 1 && data[0]) {
    const detail = await getLineChatDetail({
      username,
      params: { category: 'LINE_CHAT_DETAIL', offset: 0, limit: 50, deviceUdid, rid: String(data[0].PK) }
    })
    defaultSelectData = detail.data.contents?.map(item => ({
      ...item,
      time: dayjs(item.date).format('YYYY-MM-DD HH:mm'),
      defaultAvata: '/images/avatars/10.png'
    })) || []
  }

  return {
    data,
    defaultSelectData,
    leftTotalCount: response.data.totalCount,
    advanced,
    replaceList: !advanced,
    nextLeftPage: advanced ? page : 0
  }
}

const loadDetail = async ({ contact, page }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const response = await getLineChatDetail({
    username: deviceUser?.username || '',
    params: {
      category: 'LINE_CHAT_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid: currentDevice?.['Unique Identifier'] || '',
      rid: String(contact.PK)
    }
  })
  const selected = response.data.contents?.map(item => ({
    ...item,
    time: dayjs(item.date).format('YYYY-MM-DD HH:mm'),
    defaultAvata: '/images/avatars/1.png'
  })) || []

  return { selected, rightTotalCount: response.data.totalCount }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'Line',
  storeKey: 'Line',
  actionPrefix: 'line',
  contactKey: 'PK',
  storageKey: 'lineItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({
    chats: null,
    contacts: null,
    userProfile: {
      id: 11,
      avatar: '/images/call-log/1.webp',
      fullName: 'John Doe',
      role: 'admin',
      about: 'Dessert chocolate cake lemon drops jujubes.',
      status: 'online',
      settings: { isTwoStepAuthVerificationEnabled: true, isNotificationsOn: false }
    },
    preViewImage: { open: false, url: '' },
    advanced: true,
  }),
  applySummary: (state, payload) => {
    state.advanced = [true, 'true'].includes(payload.advanced)
  }
})

export const fetchChatsContacts = chat.fetchSummary
export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const setPerViewImage = chat.setPerViewImage
export const removeSelectedChat = chat.removeSelectedChat
export default chat.reducer
